/**
 * Banner Slider
 *
 * @since 1.0.0
 * @package geo_med
 */

(function($) {


	var imagesArray = new Array();
	$('.banner-slider ul.slides li').each(function() {
	    imagesArray.push($(this).find('img').attr('src'));
	});
	var imagesLength = imagesArray.length;
	function preload(images) {
		for (i = 0; i < imagesLength; i++) {
			image = new Image();
			image.src = images[i];
		}
	}
	preload(imagesArray);

	$(document).ready(function(){
		$('.banner-slider').slider({
			height: 	680,
			transition: 800,
			interval: 	7000
		});
	});

	/**
	 * Dynamically check word count and add class
	 * for responsive font sizing
	 */
	if ( $('.banner-slider').length > 0 ) {

		$(".banner-slider .caption h1").each( function() {

			var $this = $(this);
			var $numWords = $this.text().split(" ").length;

			if ( ($numWords >= 1) && ($numWords < 7) ) {
			    $this.addClass('small');
			}
			else if ( ($numWords < 15) ) {
			    $this.addClass('medium');
			}
			else if ( ($numWords < 20) ) {
			    $this.addClass('large');
			}
			else if ( ($numWords < 30) ) {
			    $this.addClass('xlarge');
			}
			else {
			    $this.addClass('xxlarge');
			}
		} );
	}

	/**
	 * Dynamically check word count and add class
	 * for responsive font sizing
	 */
	if ( $('.banner-blog-listing').length > 0 ) {

		$(".banner-blog-listing .featured-content h1").each( function() {

			var $this = $(this);
			var $numWords = $this.text().split(" ").length;

			if ( ($numWords >= 1) && ($numWords < 7) ) {
			    $this.addClass('small');
			}
			else if ( ($numWords < 15) ) {
			    $this.addClass('medium');
			}
			else if ( ($numWords < 20) ) {
			    $this.addClass('large');
			}
			else if ( ($numWords < 30) ) {
			    $this.addClass('xlarge');
			}
			else {
			    $this.addClass('xxlarge');
			}
		} );
	}

})(jQuery);